import React, { useEffect } from 'react';
import { Route } from 'react-router-dom';
import TopNavigation from '../components/TopNavigation';
import PublicFooter from '../parent-portal/shared/PublicFooter';
import Footer from 'parent-portal/shared/Footer/Footer';
import { Environment } from 'environmentVariables';

const GTM_ID = 'GTM-P7CNHF4K';

export const Public = ({ component: Component, ...rest }) => {
    useEffect(() => {
        if (Environment.toLowerCase() === 'production') {
            if (!document.getElementById('gtm-init-script')) {
                const inlineScript = document.createElement('script');
                inlineScript.id = 'gtm-init-script';
                inlineScript.type = 'text/javascript';
                inlineScript.appendChild(
                    document.createTextNode(`
                    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer','${GTM_ID}');
                `),
                );
                document.head.appendChild(inlineScript);
            }

            if (!document.getElementById('hs-script-loader')) {
                const hubspotScript = document.createElement('script');
                hubspotScript.src = '//js.hs-scripts.com/24317509.js';
                hubspotScript.type = 'text/javascript';
                hubspotScript.async = true;
                hubspotScript.defer = true;
                hubspotScript.id = 'hs-script-loader';
                document.body.appendChild(hubspotScript);
            }
        }

        return () => {
            document.getElementById('gtm-script')?.remove();
            document.getElementById('hs-script-loader')?.remove();
        };
    }, []);

    return (
        <Route
            {...rest}
            render={(props) => (
                <>
                    {Environment.toLowerCase() === 'production' && (
                        <noscript>
                            <iframe
                                src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
                                height="0"
                                width="0"
                                style={{ display: 'none', visibility: 'hidden' }}
                                title="GTM"
                            ></iframe>
                        </noscript>
                    )}
                    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
                        <TopNavigation />
                        <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                            <Component {...props} />
                        </div>
                        <Footer />
                        <div style={{ position: 'fixed', bottom: 0, right: 0 }}>
                            <PublicFooter />
                        </div>
                    </div>
                </>
            )}
        />
    );
};
